import { Placeholder } from '@/shared/components/layout/Placeholder';

export function ChatBotPage() {
  return (
    <Placeholder
      title="ChatBot"
      subtitle="Asistente conversacional"
      description="Próximamente."
    />
  );
}
